export default __webpack_public_path__ + "static/icon-19-6-da47bf187a5530e4af56ac3fdab59350.png";